// extracted by mini-css-extract-plugin
export default {"header":"WidgetTitle_header__AGLeA","title":"WidgetTitle_title__yTl3J","addon":"WidgetTitle_addon__B9ZXA"};